"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSSROrigin = setSSROrigin;
exports.useHeaders = useHeaders;
exports.useSSRHook = useSSRHook;
var react_1 = require("react");
var renderingData_1 = require("./renderingData");
var origin = "";
function setSSROrigin(url) {
    origin = url;
}
function useHeaders(headers) {
    for (var _i = 0, _a = Object.entries(headers); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        (0, renderingData_1.setRenderingHeader)(key, value);
    }
    (0, react_1.useEffect)(function () {
        if (headers.title)
            document.title = headers.title;
    }, [headers.title]);
}
function useSSRHook(url) {
    var _this = this;
    var refMounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        refMounted.current = true;
        return function () {
            refMounted.current = false;
        };
    }, []);
    var _a = (0, react_1.useState)(function () { return (0, renderingData_1.getRenderingValue)(url); }), response = _a[0], setResponse = _a[1];
    var _b = (0, react_1.useState)(0), reloadVariable = _b[0], setReloadVariable = _b[1];
    var reload = (0, react_1.useMemo)(function () { return function () { return setReloadVariable(function (v) { return v + 1; }); }; }, []);
    // null for first render to keep SSR 
    var refLast = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (refLast.current === null) {
            refLast.current = {};
            if (response !== null)
                return;
        }
        // set origin for browser by default
        if (origin === "")
            origin = window.location.origin;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var last, res, value, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        last = refLast.current = {};
                        return [4 /*yield*/, fetch(url.startsWith("/") ? origin + url : url)];
                    case 1:
                        res = _a.sent();
                        if (res.status !== 200)
                            throw new Error("Response status: ".concat(res.status));
                        return [4 /*yield*/, res.json()];
                    case 2:
                        value = _a.sent();
                        // if last !== refLast.current there is running last called fetch
                        if (last === refLast.current && refMounted.current)
                            setResponse(value);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof Error) {
                            if (refMounted.current)
                                setResponse(e_1);
                        }
                        else {
                            if (refMounted.current)
                                setResponse(new Error("Unknown error"));
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [url, reloadVariable]);
    if (response === null) {
        return [null, null, true, reload];
    }
    else if (response instanceof Error) {
        return [null, response, false, reload];
    }
    else {
        return [response, null, false, reload];
    }
}
